import { useState } from 'react'

import { Box } from '@factorialco/deprecated-design-system'
import { PerformanceEmployeesForSelectDocument } from 'generated/resources/graphql'

import { EmployeeForSelectFragmentNoAccess } from 'modules/core/components/EntitySelectWrapper/Entities/Employees/types'
import Loading from 'modules/core/components/Loading'
import { useQuery } from 'modules/core/hooks/useQuery'
import i18n from 'modules/core/lib/i18n'

import { EmployeeSelector } from 'modules/employees/components/EmployeeSelector'

import { Variables } from './targetEnums'

interface Props {
  variables: Variables
  onSelectEmployees: (employees: EmployeeForSelectFragmentNoAccess[]) => void
}

export const ManualEmployeeFilter = ({ variables, onSelectEmployees }: Props) => {
  const [selectorEmployees, setSelectorEmployees] = useState<EmployeeForSelectFragmentNoAccess[]>(
    []
  )
  const [fetched, setFetched] = useState(false)

  const { loading } = useQuery(PerformanceEmployeesForSelectDocument, {
    variables:
      variables.targetStrategy === 'by_employees'
        ? { ids: variables.arguments }
        : { accessIds: variables.arguments },
    skip:
      fetched ||
      !variables.arguments?.length ||
      (variables.targetStrategy !== 'by_employees' &&
        variables.targetStrategy !== 'manual_selection'),
    onCompleted: (data) => {
      setSelectorEmployees(data.employees.employeeNames)
      setFetched(true)
    },
  })

  if (loading) {
    return <Loading />
  }

  return (
    <Box gap="s24" alignItems="flexEnd" data-testid="target-group-manual-employee-filter">
      <EmployeeSelector
        label={i18n.t('common.employees')}
        emptyLabel={i18n.t('common.select')}
        disabled={false}
        value={selectorEmployees}
        onSelect={setSelectorEmployees}
        onPopoverClose={() => onSelectEmployees(selectorEmployees)}
        multiple
      />
    </Box>
  )
}
